export var EventType;
(function (EventType) {
    EventType[EventType["Start"] = 0] = "Start";
    EventType[EventType["Data"] = 1] = "Data";
    EventType[EventType["End"] = 2] = "End";
})(EventType || (EventType = {}));
